import React from "react";
import "../style/banner.css";
import loadImage from "../../../assets/images/load.gif";
export default function Button(props) {

  return (
    <>
      <div className="buttonContainer">
        <button
          onClick={() => props.onClick(props.id, props.urlPdf)}
          className={props.isClicked ? "buttonOnClick" : "button"}
          onMouseOver={props.onMouseHover}
          onMouseLeave={props.onMouseLeave}
        >
          <img src={props.imgSrc} alt='' />
          {props.isClicked ? (
            <img className="loadImage" src={loadImage} alt='' />
          ) : (
            <label className="btnText"> {props.text}</label>
          )}
        </button>
      </div>
    </>
  );
}
